import { h } from "../../core/dom.js";

const HOUR = 60 * 60 * 1000;

export function mountUpdatePrompt(registerSW, app, root = document.body) {
  let update = null;
  const banner = h("div", { class: "update-banner hidden", role: "status" },
    h("span", {}, "È disponibile una nuova versione di PAWS."),
    h("div", { class: "update-actions" },
      h("button", { class: "btn btn-ghost", type: "button", onclick: () => banner.classList.add("hidden") }, "Più tardi"),
      h("button", { class: "btn btn-primary", type: "button", onclick: () => update && update(true) }, "Aggiorna")));
  root.append(banner);
  update = registerSW({
    immediate: true,
    onNeedRefresh() {
      banner.classList.remove("hidden");
    },
    onOfflineReady() {
      app.toast("PAWS ora funziona anche senza connessione", "success");
    },
    onRegisteredSW(_url, registration) {
      if (registration) setInterval(() => registration.update().catch(() => {}), HOUR);
    },
    onRegisterError(error) {
      app.reporter?.report(error, "service-worker");
    }
  });
  return { banner, check: () => update && update() };
}
